<template>
  <v-dialog
    v-model="visible"
    max-width="1024"
    @keydown.esc="reject()"
    @keydown.enter="accept()"
  >
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }}</span>
        <v-btn icon right absolute v-ripple @click.prevent="visible = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <output-panel :code="code" :data="data"> </output-panel>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import outputPanel from "@/components/panels/OutputPanel";
import i18n from "@/app/plugins/i18n";

export default {
  name: "OutputDialog",
  components: {
    outputPanel
  },
  props: {
    acceptColor: {
      type: String,
      required: false,
      default: "success"
    },
    rejectColor: {
      type: String,
      required: false,
      default: "red darken-1"
    },
    acceptPrompt: {
      type: String,
      required: false,
      default: "OK"
    },
    rejectPrompt: {
      type: String,
      required: false,
      default: "No"
    },
    code: {
      required: false,
      default: false
    },
    data: {
      required: false
    },
    title: {
      required: false,
      default: i18n.t("App.output")
    }
  },
  data() {
    return {
      visible: false,
      value: "",
      promise: null,
      promiseResolve: null,
      promiseReject: null
    };
  },

  methods: {
    open() {
      this.visible = true;
      this.promise = new Promise((resolve, reject) => {
        this.promiseResolve = resolve;
        this.promiseReject = reject;
      });
      return this.promise;
    },
    accept() {
      this.visible = false;
      this.promiseResolve(this.value);
    },
    reject() {
      this.visible = false;
      this.promiseReject(this.value);
    }
  }
};
</script>
